import { useTranslation } from 'react-i18next';
import { Alert, Box, Typography } from '@mui/material';
import { McpAuthFrame, McpIntro } from '../components/McpUi';

export default function McpProviderResult() {
  const { t } = useTranslation();
  const status = new URLSearchParams(window.location.search).get('status');
  const success = status === 'connected';
  return <McpAuthFrame>
    <McpIntro title={t(success ? 'mcp_provider_connected_title' : 'mcp_provider_failed_title')} subtitle={t('mcp_provider_result_subtitle')} />
    <Alert severity={success ? 'success' : 'warning'} sx={{ mt: 3 }}>
      {t(success ? 'mcp_provider_connected_body' : 'mcp_provider_failed_body')}
    </Alert>
    <Box sx={{ mt: 3 }}><Typography variant="body2" color="text.secondary">{t('mcp_provider_result_return')}</Typography></Box>
  </McpAuthFrame>;
}
